module.exports = __webpack_public_path__ + "img/columns.bf878506.svg";